import React, { useState } from 'react'
import Category from './Category'


const SalaryCalc = () => {

   const [salaryCategory, setSalaryCategory] = useState({
         hourly: {id:1,name: "Hourly",unadjusted: "30",adjusted: "27.12"},
         daily: {id:2,name: "Daily",unadjusted: "240",adjusted: "216.92"},
         weekly: {id:3,name: "Weekly",unadjusted: "1200",adjusted: "1085"},
         biweekly: {id:4,name: "Bi-Weekly",unadjusted: "2400",adjusted: "2169"},
         semimonthly: {id:5,name: "Semi-Monthly",unadjusted: "2600",adjusted: "2350"},
         monthly: {id:6,name: "Monthly",unadjusted: "5200",adjusted: "4700"},
         quarterly: {id:7,name: "Quarterly",unadjusted: "15600",adjusted: "14100"},
         annual: {id:8,name: "Annual",unadjusted: "62400",adjusted: "56400"},
   })

   const [salary, setSalary] = useState('30');
   const [payPeriod, setPayPeriod] = useState('hour');
   const [hoursPerWeek, setHoursPerWeek] = useState('40');
   const [daysPerWeek, setDaysPerWeek] = useState('5');
   const [holidaysPerYear, setHolidaysPerYear] = useState('10');
   const [vacationDaysPerYear, setVacationDaysPerYear] = useState('15');

   const calculateSalary = () => {
      // Calculate adjusted and unadjusted salaries based on inputs
      let hourlyRate;
      switch (payPeriod) {
        case 'hour':
          hourlyRate = salary;
          break;
        case 'day':
          hourlyRate = salary / (hoursPerWeek / daysPerWeek);
          break;
        case 'week':
          hourlyRate = salary / hoursPerWeek;
          break;
        case 'biweek':
          hourlyRate = salary / (hoursPerWeek * 2);
          break;
        case 'semimonth':
          hourlyRate = salary / (hoursPerWeek * daysPerWeek * 2);
          break;
        case 'month':
          hourlyRate = salary / (hoursPerWeek * daysPerWeek * 4);
          break;
        case 'quarter':
          hourlyRate = salary / (hoursPerWeek * daysPerWeek * 12);
          break;
        case 'Year':
          hourlyRate = salary / (hoursPerWeek * daysPerWeek * 52);
          break;
        default:
          hourlyRate = 0;
          break;
      }
  
      
      
      // calculate unadjusted salary 
      const unadjustedSalary = hourlyRate * (hoursPerWeek/daysPerWeek)* daysPerWeek * 52;

      // Calculate adjusted salary
      let totalDaysAfterVacation = (parseInt(holidaysPerYear) + parseInt(vacationDaysPerYear))
      const adjustedSalary = hourlyRate * (hoursPerWeek/daysPerWeek) * ((52 * daysPerWeek)-totalDaysAfterVacation)

      setSalaryCategory(prevState => ({
         ...prevState,
         hourly: {
            ...prevState.hourly,
            adjusted: (adjustedSalary / 52)/hoursPerWeek,
            unadjusted:hourlyRate
         },
         daily: {
            ...prevState.daily,
            adjusted: (adjustedSalary / 52)/daysPerWeek,
            unadjusted:hourlyRate * (hoursPerWeek/daysPerWeek)
         },
         weekly: {
            ...prevState.weekly,
            adjusted: adjustedSalary / 52,
            unadjusted:unadjustedSalary / 52
         },
         biweekly: {
            ...prevState.biweekly,
            adjusted: adjustedSalary / 26,
            unadjusted:unadjustedSalary / 26
         },
         semimonthly: {
            ...prevState.semimonthly,
            adjusted: adjustedSalary / 24,
            unadjusted:unadjustedSalary / 24
         },
         monthly: {
            ...prevState.monthly,
            adjusted: adjustedSalary / 12,
            unadjusted:unadjustedSalary / 12
         },
         quarterly: {
            ...prevState.quarterly,
            adjusted: adjustedSalary / 4,
            unadjusted:unadjustedSalary / 4
         },
         annual: {
           ...prevState.annual,
           adjusted: adjustedSalary,
           unadjusted:unadjustedSalary
         }
       }))
   } 
   
   

   return (
      <div className="w-full max-w-[1000px] bg-gray-100 mx-auto py-10 md:px-[30px] rounded-sm drop-shadow-lg flex flex-col lg:flex-row gap-[20px]">
         <div className="max-w-[100%] lg:w-[50%] h-full bg-white p-[10px] md:p-[20px]">
            <div className="flex flex-col">
               <div className="text-gray-500 flex flex-col gap-[10px]">
                  <h3 className="text-gray-500 font-medium text-[18px]">Salary Amount</h3>
                  <div className="flex justify-between items-center">
                     <div className="">
                        <input
                           className="rounded-md border text-gray-500 outline-none py-2 px-3 w-[150px] h-[50px]"
                           id=""
                           name=""
                           type="text"
                           placeholder=""
                           required
                           value={salary}
                           onChange={(e)=>{setSalary(e.target.value)}}
                        />
                     </div>
                     <div className="flex flex-col sm:flex-row items-center">
                        per &nbsp;&nbsp;<select
                           className="border outline-none rounded-md w-[150px] h-[50px]"
                           id=""
                           name=""
                           required
                           value={payPeriod}
                           onChange={(e)=>{setPayPeriod(e.target.value)}}
                        >
                           <option value="hour">Hour</option>
                           <option value="day">Day</option>
                           <option value="week">Week</option>
                           <option value="biweek">Bi-Week</option>
                           <option value="semimonth">Semi-Month</option>
                           <option value="month">Month</option>
                           <option value="quarter">Quarter</option>
                           <option value="year">Year</option>
                        </select>
                     </div>
                  </div>
                  <div className="flex justify-between items-center">
                     <h3 className="text-gray-500 font-medium text-[18px]">Hours per Week</h3>
                     <input
                        className="rounded-md border text-gray-500 outline-none py-2 px-3 w-[150px] h-[50px]"
                        id=""
                        name=""
                        type="text"
                        placeholder=""
                        required
                        value={hoursPerWeek}
                        onChange={(e)=>{setHoursPerWeek(e.target.value)}}
                     />
                  </div>
                  <div className="flex justify-between items-center">
                     <h3 className="text-gray-500 font-medium text-[18px]">Days per Week</h3>
                     <input
                        className="rounded-md border text-gray-500 outline-none py-2 px-3 w-[150px] h-[50px]"
                        id=""
                        name=""
                        type="text"
                        placeholder=""
                        required
                        value={daysPerWeek}
                        onChange={(e)=>{setDaysPerWeek(e.target.value)}}
                     />
                  </div>
                  <div className="flex justify-between items-center">
                     <h3 className="text-gray-500 font-medium text-[18px]">Holidays per year</h3>
                     <input
                        className="rounded-md border text-gray-500 outline-none py-2 px-3 w-[150px] h-[50px]"
                        id=""
                        name=""
                        type="text"
                        placeholder=""
                        required
                        value={holidaysPerYear}
                        onChange={(e)=>{setHolidaysPerYear(e.target.value)}}
                     />
                  </div>
                  <div className="flex justify-between items-center">
                     <h3 className="text-gray-500 font-medium text-[18px]">Vacation days per year</h3>
                     <input
                        className="rounded-md border text-gray-500 outline-none py-2 px-3 w-[150px] h-[50px]"
                        id=""
                        name=""
                        type="text"
                        placeholder=""
                        required
                        value={vacationDaysPerYear}
                        onChange={(e)=>{setVacationDaysPerYear(e.target.value)}}
                     />
                  </div>
                  <button onClick={calculateSalary} className="w-full h-[50px] mt-[20px] bg-violet-500 hover:opacity-75 text-white font-medium text-[18px] rounded-lg shadow-2xl">Calculate</button>
               </div>
            </div>
         </div>
         <div className="w-[100%] lg:w-[50%] h-full">
            <h3 className="text-white py-[2px] mb-[10px] h-[50px] flex items-center text-center justify-center px-[10px] font-medium text-[25px] bg-violet-500">Result</h3>
            <div className="w-full flex flex-col">
            <div className="flex items-center justify-between text-gray-700 min-h-[40px]">
               <div className="w-1/3 px-[5px]"></div>
               <div className="w-1/3 px-[5px]">Unadjusted</div>
               <div className="w-1/3 px-[5px]">Holidays & Vacation Days Adjusted</div>
            </div>
               <div className="w-full h-[1px] bg-gray-400"></div>
               {
                  Object.keys(salaryCategory).map((key) => {
                     return <Category key={salaryCategory[key].key} name={salaryCategory[key].name} unadjusted={salaryCategory[key].unadjusted} adjusted={salaryCategory[key].adjusted} />
                  })
               }
            </div>
         </div>
      </div>
   )
}

export default SalaryCalc
